// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Cpl_v","skeleton-animation":"styles_skeleton-animation__Wvl4Y"};